import React, { Component } from 'react';
import { Text, Group, Stage, Layer, Rect, Line} from 'react-konva';
import { connect } from "react-redux";
import {START, END} from './constants.js';
import Tone from 'tone';
import {getWidth, WIDTH, HEIGHT} from './constants.js';
import Colors from 'components/Colors.js';

window.markerY = 0;
const colors = new Colors();
const SELECTED_SLICE_HEIGHT = 3;

class Markers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            buffer: props.buffer,
            ticks: [],
            offset: 0,
            endOffset: 0
        };
        this.width = this.props.width;
        this.height = props.height || HEIGHT;
        this.state.startX = this.convertSecondsToSpace(props.start, props.scale);
        this.state.endX = this.convertSecondsToSpace(props.end, props.scale);
        this.calculateTicks(undefined, undefined, undefined, true);
    }

    calculateTicks(
        start=this.props.start,
        end=this.props.end,
        scale = this.props.scale,
        update=false) {

        /*
        let ticks = [];
        let step = new Tone.Time('16n').toMilliseconds() / 1000.0;
        if (this.props.track.isWarped() && this.props.sampler.tempo > 0) {
            let warpRatio = this.props.track.sequencerEngine.bpm  / this.props.sampler.tempo;
            step *= warpRatio;
        }
        //let warpRatio = this.props.sampler.tempo / this.props.

        if (this.props.transpose > -12) {
            step = step * (1 + this.props.transpose / 12.0)
        } else {
            step = new Tone.Time('8n').toMilliseconds() / 1000.0;
            step = step * (-6 / this.props.transpose);
        }
        let length = (end - start) / step;
        if (length > 10) {
            step *= Math.pow(2, Math.floor(length / 64));
        }

        let i = 0;
        while (start < end) {
            let x = Math.floor(
                this.convertSecondsToSpace(start, scale));
            let height = i % 4 === 0 ? 20 : 10;
            ticks.push({
                x: x,
                height: height
            });
            start += step;
            i++;

            if (x >= this.width) {
                break;
            }
        }
        this.state.ticks = ticks;
        if (update) {
            this.setState(this.state);
        }
        */
    }

    shouldComponentUpdate(nextProps, nextState) {
        this.width = nextProps.width;
        this.height = nextProps.height;
        if (this.state.buffer != nextProps.buffer ||
            this.props.scale !== nextProps.scale ||
            this.props.zoomedStartTime !== nextProps.zoomedStartTime ||
            this.props.width || nextProps.width ||
            this.props.start !== nextProps.start ||
            this.props.end !== nextProps.end 
            ) {
            this.state.buffer = nextProps.buffer;
            let startTime = nextProps.start;
            let endTime = nextProps.end;
            this.state.startX = this.convertSecondsToSpace(startTime, nextProps.scale);
            this.state.endX = this.convertSecondsToSpace(endTime, nextProps.scale);
            this.calculateTicks(startTime, endTime, nextProps.scale);
        }

        if (
            this.props.transpose !== nextProps.transpose ||
            this.props.bpm !== nextProps.bpm) {
            let startTime = nextProps.start;
            let endTime = nextProps.end;
            this.calculateTicks(startTime, endTime, nextProps.scale);
        }

        return true;
    }

    convertSpaceToSeconds(x) {
        return this.state.buffer.duration * x / this.width
    }

    convertSecondsToSpace(x) {
        return x / this.state.buffer.duration * this.width
    }

    render() {
        var triangleHeight = this.props.small ? 14 : 20;
        var triangleWidth = this.props.small ? 14 : 20;
        var startTrianglePts = [
            0, 0,
            triangleWidth, triangleHeight,
            0, triangleHeight
        ];

        var endTrianglePts = [
            0, this.height,
            -triangleWidth, this.height,
            0, this.height - triangleHeight
        ];
      
        if (this.props.isSelectedSlice) {
            endTrianglePts[1] -= 2;
            endTrianglePts[3] -= 2;
            endTrianglePts[5] -= 2;
        }

        let selectedSliceColor = this.props.color || colors.getColor(this.props.sliceNumber);
        let sliceStart = this.state.startX;
        let sliceEnd = this.state.endX;

        let text = (this.props.sliceNumber + 1);
        let mapping = this.props.track.getKeyMapping(this.props.sliceNumber);

        return (
            <Group>
               {this.props.isSelectedSlice ? 
                <Rect
                    x={sliceStart}
                    y={0}
                    width={sliceEnd - sliceStart}
                  opacity={0.1}
                    height={this.height}
                    fill={selectedSliceColor}/>
                 : <Rect></Rect>}
              <Line
                points={[this.state.startX, 0, this.state.startX, this.height] }
                strokeWidth={this.props.small ? 1 : 2}
                stroke={this.props.color}
                opacity={0.8}
                alpha={0.8}
                fill={this.props.color}/>
              <Line
                onMouseDown={(e) => this.props.onStartSliceStartedDragging(
                    e.evt.pageX - this.state.startX, e.evt.metaKey || e.evt.ctrlKey)}
                onMouseUp={this.props.onStartSliceStroppedDragging}
                onKeyDown={(event) => this.props.onKeyDown(event)}
                x={this.state.startX}
                y={0}
                style={{cursor: 'pointer'}}
                opacity={0.9}
                points={startTrianglePts}
                closed={true}
                strokeWidth={1}
                stroke={this.props.color}
                fill={this.props.color}
                />
             <Line
                points={[this.state.endX, 0, this.state.endX, this.height] }
                strokeWidth={this.props.small ? 1 : 2}
               stroke={this.props.color}
               fill={this.props.color}/>
              <Line
                onMouseDown={(e) => this.props.onEndSliceStartedDragging(e.evt.pageX - this.state.endX, e.evt.metaKey || e.evt.ctrlKey)}
                onMouseUp={this.props.onEndSliceStoppedDragging}
                x={this.state.endX}
                y={0}
                style={{cursor: 'pointer'}}
                opacity={0.9}
                points={endTrianglePts}
                closed={true}
                strokeWidth={1}
                stroke={this.props.color}
                fill={this.props.color}
                />
                {this.props.isSelectedSlice ? 
                <Rect
                    x={sliceStart}
                    y={this.height - SELECTED_SLICE_HEIGHT}
                    width={sliceEnd - sliceStart}
                    height={SELECTED_SLICE_HEIGHT}
                    fill={selectedSliceColor}/>
                 : <Rect></Rect>}
               {this.props.isSelectedSlice ? 
                 this.state.ticks.map(
                    tick =>
                    <Line x={tick}
                        y={0}
                        style={{cursor: 'pointer'}}
                        points={[tick.x, this.height, tick.x, this.height - tick.height]}
                        closed={true}
                        opacity={tick.height === 20 ?  '0.55' : '0.4'}
                        strokeWidth={1}
                        stroke={this.props.color}
                        fill={this.props.color}/>
                 ) : <Rect></Rect>}
            {/*<Text
                onMouseDown={(e) => this.props.onStartSliceStartedDragging(
                    e.evt.pageX - this.state.startX, e.evt.metaKey || e.evt.ctrlKey)}
                onMouseUp={this.props.onStartSliceStroppedDragging}
                fill="black"
                fontSize={this.props.small ? 8 : 10}
                text={text} x={this.props.small ? this.state.startX + 2 : this.state.startX + 5} y={this.props.small ? 6 : 10}/>
             */}
             </Group>
              ); 
    }
}

const mapStateToProps = (state, props) => {
    let transpose = state.effects.effectParameters[props.transposeParameter.id];
    let slice = state.tracks.sampleSlices[props.sampler.id][props.sliceNumber];
    if (slice === undefined) {
        return {};
    }
    return {
        bpm: state.user.bpm,
        transpose: transpose,
        start: slice.startTime - props.zoomedStartTime,
        end: slice.endTime - props.zoomedStartTime,
    };
};
 

export default connect(mapStateToProps, null)(Markers);
